import React, {Fragment, useMemo} from "react";
import {Box, Card, Checkbox, FormControlLabel, FormGroup} from "@mui/material";

const WmsLayersLegend = ({layers, visibleLayers, onChange}) => {
  const layersCount = useMemo(() => (layers || []).length || null, [layers]);

  return (
    <Box
      className="viewer-wms-map__legend"
      sx={{
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column"
      }}
    >
      <Card
        variant="outlined"
        className="viewer-wms-map__legend__card"
        sx={{
          padding: "8px",
          maxHeight: "100%",
          overflow: "auto"
        }}
      >
        <FormGroup>
          {layers.map((layerLegend, idx) => (
            <Fragment key={idx}>
              {layersCount > 1 ? (
                <FormControlLabel
                  label={layerLegend.Label || layerLegend.LayerName}
                  control={
                    <Checkbox
                      checked={visibleLayers.includes(layerLegend.LayerName)}
                      onChange={ev => onChange(layerLegend.LayerName, ev.target.checked)}
                    />
                  }
                  sx={{
                    marginBottom: "8px"
                  }}
                />
              ) : (
                <Box
                  sx={{
                    marginBottom: "8px"
                  }}
                >
                  {layerLegend.Label || layerLegend.LayerName}
                </Box>
              )}

              <Box
                sx={{
                  marginLeft: layersCount > 1 ? "46px" : 0,
                  marginBottom: "12px"
                }}
              >
                <img src={layerLegend.Url} width={layerLegend.Width} height={layerLegend.Height} />
              </Box>
            </Fragment>
          ))}
        </FormGroup>
      </Card>
    </Box>
  );
};

export default WmsLayersLegend;
